<template>
  <div class="p-relative z-index-1">
    <div class="d-flex align-start justify-space-between">
      <select-asset
        :assets="assets"
        :selectedAsset="selectedAsset"
        :balances="balances"
        :readonly="isAssetReadonly"
        @setAsset="setAsset"
      />
      <enter-amount
        v-model="amount"
        :selectedAsset="selectedAsset"
        :maxAmount="maxAmount"
      />
    </div>
    <div class="mt-16">
      <c-btn class="width-100" :disabled="amount <= 0 || vaultInfo.depositDisabled" @click="setAmount"
        >Continue</c-btn
      >
    </div>
  </div>
</template>

<script>
import SelectAsset from "./SelectAsset.vue";
import EnterAmount from "./EnterAmount.vue";
import { mapGetters } from "vuex";
import BN from "bignumber.js";

export default {
  components: {
    SelectAsset,
    EnterAmount,
  },
  props: {
    vaultInfo: Object,
    selectedAsset: Object,
    txPayload: Object,
    balances: Object,
    isAssetReadonly: Boolean,
  },
  computed: {
    ...mapGetters({
      allVaults: "projectConfig/allVaults",
    }),
    estimatedTxFees() {
      return 0.005;
    },
    assets() {
      return this.allVaults
        .map(v =>
          (v.tokens || [v]).map(item => ({
            ...item,
            vault: v.vault,
            type: v.type,
          }))
        )
        .flat();
    },
    maxAmount() {
      const fees =
        this.selectedAsset?.coin === "eth" ? this.estimatedTxFees : 0;
      const max = new BN(this.balances?.[this.selectedAsset?.coin]?.value || 0)
        .minus(fees)
        .toNumber();
      return Math.max(max, 0);
    },
  },
  data: () => ({
    amount: 0,
  }),
  methods: {
    setAsset(asset) {
      this.$emit("selectAsset", asset);
    },
    setAmount() {
      this.$emit("next", this.amount);
    },
  },
  mounted() {
    this.amount = this.txPayload.amount || 0;
  },
};
</script>
